/* Common Imports */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

/* Component Imports */
import { Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useState } from "react";
import AmenitiesIconCard from "./sub-components/AmenitiesIconCard";
const useStyles = makeStyles((theme) => ({
  megaContainer: {
    /* XXS breakpoint */
    [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
      padding: "0rem 0.5rem 1rem 0.5rem",
    },
    [theme.breakpoints.only("xs")]: {
      padding: "0rem 1.5rem 1rem 1.5rem",
    },
    [theme.breakpoints.only("sm")]: {
      padding: "0rem 3rem 1rem 3rem",
    },
    [theme.breakpoints.only("md")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    [theme.breakpoints.only("lg")]: {
      padding: "0rem 4rem 1rem 4rem",
    },
    /* XLG breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
      padding: "0rem 5rem 1rem 5rem",
    },
    /* Full HD breakpoint */
    [theme.breakpoints.up("xl")]: {
      padding: "0rem 23rem 1rem 23rem",
    },
    /* XXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
      padding: "0rem 36rem 1rem 36rem",
    },
    /* XXXL breakpoint */
    [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
      padding: "0rem 72rem 1rem 72rem",
    },

    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  mainContainer: {
    padding: "0rem 8rem 0rem 8rem",
    [theme.breakpoints.down("lg")]: {
      padding: "0rem 8rem 0rem 8rem",
    },
    [theme.breakpoints.up("lg")]: {
      margin: "4rem 0rem 2rem 0rem",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      padding: "0rem",
    },
    width: "100%",
  },
  heading: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "1.25rem",
    flexWrap: "wrap",
    margin: "0rem 0rem 2rem 0rem",
  },
  subHeading: {
    margin: "0rem 0rem 0.5rem 0rem",
    color: "A8626C",
    fontWeight: "400",
    fontSize: "1.25rem",
    lineHeight: "2rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "1.25rem",
      color: "#666666",
    },
  },
  imageContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "1.5rem",
    width: "100%",
    marginTop: "2rem",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "center",
    },
  },
  imageCard: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "calc(20% - 0.5rem)",
    transition: "width 0.3s ease",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    "&:hover": {
      width: "630px",
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.80) 99.95%)",
      zIndex: 1,
      borderRadius: "8px", // Match the image's border radius
    },
  },

  image: {
    width: "100%",
    height: "510px",
    objectFit: "cover",
    borderRadius: "8px",
    transition: "width 0.3s ease, height 0.3s ease",
  },

  imageLabel: {
    position: "absolute",
    bottom: "0",
    left: "0",
    right: "0",

    color: "#FFFFFF",
    fontWeight: 500,
    textAlign: "left",
    padding: "0.5rem 0.5rem 1.5rem 1.5rem",
    fontSize: "1rem",
    zIndex: 2,
  },
  textcontainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  amenityCard: {
    width: "30%",
    // padding: "1rem",
    borderRadius: "1rem",
    border: "1px solid rgba(184, 113, 123, 0.50)",

    [theme.breakpoints.only("md")]: {
      width: "48%",
    },
    // "& img": {
    //   width: "40px",
    //   height: "40px",
    // },
    // "& svg": {
    //   width: "40px",
    //   height: "40px",
    // },
  },
  columnLayout: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    gap: "0.5rem",
  },
  dialogTitle: {
    color: "#A8626C",
    fontWeight: 600,
  },
  dialog: {
    "& .MuiPaper-root": {
      borderRadius: "1rem",
    },
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    color: "#212121",
    zIndex: 1000,
  },
  dailogtitle: {
    color: "#A8626C",
    fontWeight: 600,
    fontSize: "1.5rem",
  },
}));

const Amenities = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const images = [
    {
      src: "images/halcyon-logo/infinity_pool.webp",
      label: "Tranquility pool",
    },
    {
      src: "images/halcyon-logo/gallery/basement_parking.webp",
      label: "Basement parking",
    },
    {
      src: "images/halcyon-logo/gallery/indoor_games.webp",
      label: "Indoor games",
    },
    {
      src: "images/halcyon-logo/visitors_park.webp",
      label: "Rain tree garden",
    },
    {
      src: "images/halcyon-logo/akhada_new.webp",
      label: "Akhada",
    },
  ];

  const amenities = [
    { title: "Business center", icon: "/images/halcyon-logo/amenities/business_centre_icon.png" },
    { title: "Multi purpose hall", icon: "/images/halcyon-logo/amenities/hall_icon.png" },
    { title: "Indoor games", icon: "/images/halcyon-logo/amenities/indoor_games_icon.png" },
    { title: "Gym", icon: "/images/halcyon-logo/amenities/gym_icon.png" },
    { title: "Yoga", icon: "/images/halcyon-logo/amenities/yoga_icon.png" },
    { title: "Pool", icon: "/images/halcyon-logo/amenities/pool_icon.png" },
    { title: "Kids play area", icon: "/images/halcyon-logo/amenities/kids_play_area_icon.png" },
    { title: "Herb garden", icon: "/images/halcyon-logo/amenities/herbs_icon.png" },
    { title: "Senior citizen park", icon: "/images/halcyon-logo/amenities/senior_park_icon.png" },
    { title: "Akhada", icon: "/images/halcyon-logo/amenities/akhada_icon.png" },
    { title: "Barbeque", icon: "/images/halcyon-logo/amenities/barbecue_area_icon.png" },
    { title: "Pets play area", icon: "/images/halcyon-logo/amenities/pet_park_icon.png" },
    { title: "Pickle ball court", icon: "/images/halcyon-logo/amenities/pickle_ball.png" },
    { title: "Spike ball court", icon: "/images/halcyon-logo/amenities/spike_ball_icon.png" },
    { title: "Basket ball court", icon: "/images/halcyon-logo/amenities/basketball_icon.png" },
  ];

  const visibleAmenities = amenities;

  return (
    <React.Fragment>
      {/* <div className={classes.megaContainer}> */}
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <div className={classes.textcontainer}>
            <Typography
              variant="h6"
              component="span"
              className={classes.heading}
            >
              Amenities
            </Typography>
            <Typography
              variant="body2"
              component="span"
              className={classes.subHeading}
              onClick={handleOpen}
            >
              view all
            </Typography>
          </div>
          <div className={classes.imageContainer}>
            {images.map((image, index) => (
              <div
                key={index}
                className={classes.imageCard}
              >
                <img
                  src={image.src}
                  alt={image.label}
                  className={classes.image}
                />
                <Typography
                  variant="body2"
                  component="span"
                  className={classes.imageLabel}
                >
                  {image.label}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        className={classes.dialog}
      >
        <DialogTitle style={{ textAlign: "left", position: "relative" }}>
          <Typography
            variant="body2"
            component="span"
            className={classes.dailogtitle}
          >
            Amenities
          </Typography>
          <Button
            className={classes.closeButton}
            onClick={handleClose}
            style={{ position: "absolute", top: "10px", right: "10px" }}
          >
            <CloseIcon />
          </Button>
        </DialogTitle>

        <DialogContent>
          {" "}
          <div className={classes.cardContainer}>
            {visibleAmenities.map((amenity, index) => (
              <AmenitiesIconCard
                key={index}
                title={amenity.title}
                icon={amenity.icon}
                className={`${classes.amenityCard} ${classes.columnLayout}`}
              />
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default Amenities;
